import { jsx as _jsx } from "react/jsx-runtime";
import { cn } from '../../lib/utils';
/**
 * Renders text that browsers must NOT auto-translate (Chrome / Google Translate).
 *
 * Use it to wrap proper nouns — passenger / client first & last names — so that a
 * name like "Boucher" isn't mangled into "Butcher" when the visitor lets their
 * browser translate the page.
 */
function Name({ className, children, ...props }) {
    return (_jsx("span", { translate: "no", className: cn('notranslate', className), ...props, children: children }));
}
export { Name };
